import { useCallback, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { isAvailableFeatureSelector, isRestrictedOnTrialFeatureSelector } from 'features/billing'

import { useUpgradeSubscription } from './use_upgrade_subscription'


export const useEnforceUpgrade = (
  featureKey,
  {
    skipPreface = false,
    paywall = null,
    noTracking = false,
    type = 'popup',
    paywallOverride = null,
    onUpgradeSubscription = null,
  } = {}) => {
  const callback = useRef()
  const isAvailable = useSelector(
    featureKey
      ? (state) => (isAvailableFeatureSelector(state, { featureKey })
        && !isRestrictedOnTrialFeatureSelector(state, { featureKey }))
      : () => true
  )

  const upgradeSubscription = useUpgradeSubscription({ featureKey, skipPreface, paywall, noTracking, type, paywallOverride })

  useEffect(() => {
    if (isAvailable && callback.current) {
      callback.current()
      callback.current = null
    }
  }, [isAvailable])


  return useCallback(
    (action = () => {}) => {
      if (isAvailable) return action()

      callback.current = action
      if (onUpgradeSubscription) onUpgradeSubscription()
      return upgradeSubscription()
    },
    [isAvailable, upgradeSubscription, onUpgradeSubscription]
  )
}
